import { Instance } from 'mobx-state-tree';
import { Municipality } from '../../../store/models/Municipality';

import React from 'react';
import { Classes, Dialog } from '@blueprintjs/core';
import { IconNames } from '@blueprintjs/icons';
import { TranslatedMessage } from '../../common/translation';
import { TLCode } from '../../../common/enums/TLCode';
import { MunicipalityForm } from './MunicipalityForm';

interface MunicipalityDialogFormProps {
  municipality?: Instance<typeof Municipality>;
  onSave: (data: any) => void;
  onClose: () => void;
}

export const MunicipalityDialogForm = ({ municipality, onSave, onClose }: MunicipalityDialogFormProps) => {
  console.log(municipality);
  return (
    <Dialog
      isOpen={municipality !== undefined}
      onClose={onClose}
      icon={IconNames.EDIT}
      title={<TranslatedMessage id={TLCode.MUNICIPALITY_Edit} />}
      style={{ width: '580px' }}
      canOutsideClickClose={false}
    >
      {municipality && (
        <div className={Classes.DIALOG_BODY}>
          <MunicipalityForm
            municipality={municipality}
            onSave={onSave}
            onClose={onClose}
            dialogForm
            isCreation={false}
          />
        </div>
      )}
    </Dialog>
  );
};
